<div class="BroadcastWidth">
	<marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseout="this.start();">
		<!-- <div> -->
		<div class="MessageContainer">
			<!-- <div class="MessageGeneric EndMessage" *ngIf="lstBroadcastAlerts.length == 0">
                <label>No Messages Today</label>
            </div> -->

			<!-- <div class="MessageGeneric StartMessage" *ngIf="lstBroadcastAlerts.length > 0">
                <label>START NEW ALERTS:</label>
            </div> -->

			<div *ngFor="let ba of lstBroadcastAlerts; let i = index" class="MessageGeneric {{ GetClass(i) }}">
				<label>{{ ba }}</label>
			</div>

			<!-- <div class="MessageGeneric EndMessage" *ngIf="lstBroadcastAlerts.length > 0">
                <label>END ALERTS</label>
            </div> -->

			<!--Wrap-->
			<!-- <div class="MessageGeneric StartMessage" *ngIf="lstBroadcastAlerts.length > 0">
                <label>START NEW ALERTS:</label>
            </div>
        
            <div *ngFor="let ba of lstBroadcastAlerts; let i = index" class="MessageGeneric {{GetClass(i)}}">
                <label>{{ba}}</label>
            </div>
        
            <div class="MessageGeneric EndMessage" *ngIf="lstBroadcastAlerts.length > 0">
                <label>END ALERTS</label>
            </div>     -->
		</div>
		<!-- </div>  -->
	</marquee>
</div>
